export default __webpack_public_path__ + "static/media/sd-1-rMIN.bfcef867.avif";